<!-- <div class="mainDiv tac" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'200ms', y:'25px'}}">
  <h1>Wait just a moment ...</h1>
  <h1>Espere sólo un momento ...</h1>
  <h1>Bir dakika bekleyin ...</h1>
  <h1>Espere só um momento ...</h1>
  <h1>等一下...</h1>
  <img class="logo" [src]="urlAssets + configLogin.logoLogin">
  <div class="progBarDiv" fxLayout="row" fxLayoutAlign="center">
    <mat-progress-bar mode="buffer" fxFlex="20" class="progBar"></mat-progress-bar>
  </div>
</div> -->
<div class="mainDiv tac" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'200ms', y:'25px'}}">
  <div class="progBarDiv" fxLayout="row" fxLayoutAlign="center">
    <mat-progress-bar mode="buffer" fxFlex="20" class="progBar"></mat-progress-bar>
  </div>
</div>
